
























import api, { SubscriptionApi } from './api';
import {Vue, Component} from 'vue-property-decorator';
import DetailsSubscription from './forms/details-subscription.vue';
import PaymentMethod from './forms/payment-method.vue';
import Invoices from './forms/invoices.vue';
import DetailsSubscriptionLimits from '@/views/settings/subscription/forms/details-subscription-limits/details-subscription-limits.vue';

@Component({
  components: {
    DetailsSubscriptionLimits,
    Invoices,
    DetailsSubscription,
    PaymentMethod
  }
})
export default class SubscriptionSettings extends Vue {
  api: SubscriptionApi = api;

  load(): any {
    const subscription: Promise<any> = this.api.getSubscription();
    const customer: Promise<any> = this.api.getCustomer();
    const invoices: Promise<any> = this.api.get();
    return Promise.all([subscription, customer, invoices])
  }

  mounted() {
    this.$store.commit('loading', true);
    this.load().then(() => {
      this.$store.commit('loading', false);
    });
  }
}
